import classes from './AppDownloadLink.module.scss';
import Image from 'next/image';
import { useState, useEffect } from 'react';
import { generateAppsflyerUrl } from '../../../utils/appsflyer';
import { fireEvent } from '../../../utils/netmera';

export default function AppDownloadLink(props) {
    const { device, width, height } = props;
    const [url, setUrl] = useState(device.href || '');

    useEffect(() => {
        setUrl(generateAppsflyerUrl(device.href));
    }, [device.href]);

    return (
        <a
            target="_blank"
            rel="noopener noreferrer"
            href={url}
            onClick={() => fireEvent(device.cta_class)}
        >
            {device.image?.data?.attributes?.url ? (
                <figure className={classes.mImage}>
                    <Image
                        src={device.image?.data?.attributes?.url}
                        alt={device.name}
                        width={width}
                        height={height}
                        layout="intrinsic"
                        className={classes.aLinks}
                    />
                </figure>
            ) : (
                <p>No image available</p>
            )}
        </a>
    );
}
